import { render, staticRenderFns } from "./AkunList.vue?vue&type=template&id=e3511cf4&"
import script from "./AkunList.vue?vue&type=script&lang=js&"
export * from "./AkunList.vue?vue&type=script&lang=js&"
import style0 from "./AkunList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports